import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useScrollablePending } from './common/scrollable-wires-hooks';
import Tail from './common/wires-list-tail';
import commonProps from './common/common-props';
import useGetPaginatedPending from '../../../services/wires/pending-wires-service';
import PendingWire from './common/pending-wire';

export default function MyPendingWires() {
  const common = commonProps();
  const {
    wires, infiniteRef, expandList, showExpand,
  } = useScrollablePending({ useGetWires: useGetPaginatedPending });

  return (
    <ThemeProvider theme={common}>
      <>
        <article>
          {wires.map(wire => <PendingWire key={`my-pending-${wire.id}`} wire={wire} />)}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all pending wires</button></Tail>
          )}
        </article>
      </>
    </ThemeProvider>
  );
}
